export default {"src":"/_next/static/media/retaining-wall.bd234616.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};